import * as React from 'react';
import { FaUserTie } from "react-icons/fa";
import { IoClose, IoPeopleOutline } from "react-icons/io5";
import { getAllMembers, getTeamById, logout, stringAvatar } from '../../../service/service-call';

function InitialsAvatar({ name, size = 34 }) {
  const { sx, children } = stringAvatar(name) || {};
  const bg = sx?.bgcolor || "#262673";
  return (
    <div
      style={{ width: size, height: size, backgroundColor: bg }}
      className="flex shrink-0 items-center justify-center rounded-full text-[11px] font-bold text-white shadow-sm"
    >
      {children}
    </div>
  );
}

export default function ViewTeams({ viewTeamModal, team }) {
  const [allAdmins, setAllAdmins] = React.useState([]);
  const [allMembers, setAllMembers] = React.useState([]);
  const [tname, setTName] = React.useState('');
  const [teamId, setTeamId] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState("");
  const [selectedTeamMembers, setSelectedTeamMembers] = React.useState([]);
  const [selectedTeamMemberIds, setSelectedTeamMemberIds] = React.useState([]);

  React.useEffect(() => {
    getTeamById(team.id).then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setTName(data.teamName);
        setSelectedOption(data.teamLeadId.id);
        let arr = [];
        data.members.map((option) => arr.push(option.firstName + " " + option.lastName + " (" + option.id + ")"));
        setSelectedTeamMembers(arr);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }, []);

  React.useEffect(() => {
    getAllAdmins();
    getAllMemberForTeam();
  }, []);

  function getAllAdmins() {
    getAllMembers("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllAdmins(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  function getAllMemberForTeam() {
    getAllMembers("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllMembers(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  if (!team || !team.teamName) return null;

  return (
    <div className="relative flex flex-col">
      {/* Header */}
      <div className="relative bg-gradient-to-r from-[#1b1b3a] to-[#262673] px-6 py-5 text-center">
        <button
          onClick={() => viewTeamModal(null)}
          className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-white"
        >
          <IoClose size={18} />
        </button>
        <p className="text-sm font-bold tracking-wide text-white">{team.teamName.toUpperCase()}</p>

        <div className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-green-400/40 bg-green-400/10 px-3 py-1 text-xs font-semibold text-green-300">
          <FaUserTie size={11} />
          {team.teamLeadId.firstName.toUpperCase()} {team.teamLeadId.lastName.toUpperCase()}
        </div>
      </div>

      {/* Members list */}
      <div className="px-6 py-5">
        <p className="mb-3 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-gray-400">
          <IoPeopleOutline size={14} />
          Team Members ({team.members ? team.members.length : 0})
        </p>

        <div className="max-h-[280px] overflow-y-auto rounded-xl border border-gray-100 bg-gray-50/50 p-2">
          {team.members && team.members.length > 0 ? (
            <div className="space-y-1">
              {team.members.map((each, ind) => (
                <div
                  key={ind}
                  className="flex items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-white"
                >
                  <InitialsAvatar name={`${each.firstName} ${each.lastName}`} />
                  <p className="text-sm font-medium text-[#262673]">
                    {each.firstName.toUpperCase()} {each.lastName.toUpperCase()}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center gap-1 py-8 text-gray-300">
              <IoPeopleOutline size={20} />
              <p className="text-xs font-medium">No members in this team</p>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-gray-100 px-6 py-3 text-right">
        <button
          onClick={() => viewTeamModal(null)}
          className="rounded-lg px-4 py-2 text-sm font-semibold text-orange-500 transition-colors hover:bg-orange-50"
        >
          Close
        </button>
      </div>
    </div>
  );
}